import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VuetifyAsyncValidation from "vuetify-async-validation";

Vue.use(Vuetify);
Vue.use(VuetifyAsyncValidation);

export default new Vuetify({
});
